import { Device } from "@/api/baseDefine";
import { UserModule } from "@/store/modules/user";
import * as moment from "moment-timezone";
export class DeviceScheduleUtil {
    private deviceList: Device[] = [];
    private getSelectDevice(cls: string): Device {
        let selectDevice: Device = <Device>{};
        for (let i = 0; i < this.deviceList.length; i++) {
            if (this.deviceList[i].class == cls) {
                selectDevice = this.deviceList[i];
                break;
            }
        }
        return selectDevice;
    }

    public downLoadBuffers(buffers: any): any {
        let deviceBufferList: any = []
        for (let i = 0; i < buffers.length; i++) {
            let buffer = buffers[i];
            // this.getProperty(buffer.cls);
            let data: any = {
                id: buffer.id,
                cls: buffer.cls,
                cmd: buffer.cmd,
            };
            let bufferTime = ""
            if (data.cmd == "TSG") {
                data.action = "GET"
                data.cmdType = "Timer"
                data.actParam = buffer.act[0];
                bufferTime = buffer.get_time;
            } else if (data.cmd == "TSS") {
                data.action = "SET"
                data.cmdType = "Timer"
                bufferTime = buffer.set_time;
                let keys = Object.keys(buffer.act[0]);
                data.actParam = keys[0];
                data.actInternal = buffer.interval
            } else {
                data.action = "GET"
                data.cmdType = "Periodical"
                bufferTime = buffer.end_time;
                let keys = Object.keys(buffer.act[0]);
                data.actParam = keys[0];
                data.actInternal = buffer.interval
            }
            data.inputs = [];
            for (let i = 0; i < buffer.act.length; i++) {
                data.inputs.push({
                    value: this.formatInput(data.action, buffer.act[i])
                })
            }
            let formatTime = moment.tz(bufferTime, UserModule.zone).format();
            data.actTime = formatTime.slice(0, 19).replace("T", " ");
            deviceBufferList.push(data);
        }
        return deviceBufferList
    }

    private formatInput(action: string, input: any): string {
        if (action == "GET") {
            return input;
        } else {
            let key = Object.keys(input)
            return key[0] + ":" + input[key[0]]
        }
    }
    private parseInput(action: string, input: string): any {
        if (action == "GET") {
            return input
        }
        let out = {}
        let ss = input.split(":")
        out[ss[0]] = ss[1]
        return out;
    }
    public setDeviceList(deviceList: Device[]) {
        this.deviceList = deviceList
    }

    public reloadBuffer(deviceBufferList: any): any {
        let sendJson = {
            cmd: "BRLD",
            Buffer: new Array(),
        };

        for (let i = 0; i < 10; i++) {
            let buffer = deviceBufferList[i];
            let json = this.getOneBuferData(buffer);
            if (!!json) {
                sendJson.Buffer.push(json);
            }
        }
        return sendJson
    }

    public deleteOrAddBuffer(buffer): any {
        let json: any = null;
        if (buffer.$index < 10) {
            json = this.getOneBuferData(buffer.row);
            if (!!json) {
                json.cmd = json.cmd + "D";
            }
        } else {
            json = this.getOneBuferData(buffer.row);
        }
        return json
    }

    public getOneBuferData(buffer) {
        console.log("000000000000000000000000", buffer);
        if (
            !buffer.cls ||
            !buffer.action ||
            !buffer.cmdType ||
            !buffer.actParam ||
            !buffer.actTime
        ) {
            console.log("11111111111111111111", buffer);
            return null;
        }
        if (buffer.cmdType == "Periodical" && !buffer.actInternal) {
            console.log("222222222222222222", buffer);
            return null;
        }
        if (buffer.cmdType == "Periodical" && buffer.action == "SET") {
            return null;
        }
        if (buffer.action == "SET" && !buffer.inputs) {
            console.log("33333333333", buffer);
            return null;
        }
        let device = this.getSelectDevice(buffer.cls);
        if (!device) {
            return null;
        }
        console.log("444444444444444", buffer);
        let json: any = {
            id: device.deviceId,
            cls: buffer.cls,
            cmd: this.getCmdFromBufferData(buffer),
            act: this.getActFromBuffrer(buffer),
        };
        let formatTime = moment.tz(buffer.actTime, UserModule.zone).format();
        if (buffer.cmdType == "Timer") {
            if (buffer.action == "SET") {
                json.set_time = formatTime
                json.interval = buffer.actInternal
            } else {
                json.get_time = formatTime
            }
        } else {
            json.end_time = formatTime
            json.interval = buffer.actInternal
        }

        return json;
    }

    private getCmdFromBufferData(buffer): string {
        if (buffer.action == "GET" && buffer.cmdType == "Timer") {
            return "TSG";
        } else if (buffer.action == "SET" && buffer.cmdType == "Timer") {
            return "TSS";
        } else {
            return "PGT";
        }
    }

    private getActFromBuffrer(buffer): any {
        let act: any = [];
        for (let i = 0; i < buffer.inputs.length; i++) {
            act.push(this.parseInput(buffer.action, buffer.inputs[i].value))
        }
        return act;
    }
}